import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listFilter'
})
export class ListFilterPipe implements PipeTransform {

  transform(items: any[], property: string, text: string): any {
    if (!items || !property || !text) {
        return items;
    }
    return items.filter(item => item[property].indexOf(text) >= 0);
  }

}
